/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import "./project-sorter.scss";

import {Dropdown} from "semantic-ui-react";

import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";
import {DropdownItemProps} from "semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";



export interface ActivitySorterProps {
    auftragsverwaltung: Auftragsverwaltung;
}

@observer
export class ProjectSorter extends Component<ActivitySorterProps, any> {

    constructor(props: ActivitySorterProps) {
        super(props);
        this.state = {
            loading: false,
            sortOptions: null,
            value: this.props.auftragsverwaltung.ProjectStore.sort || ""
        };

        this.handleSortChange = this.handleSortChange.bind(this);
    }

    componentDidMount(): void {
        this.initSorter();
    }

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const {sortOptions, value} = this.state;

        if (!sortOptions) {
            return null;
        }

        return (
            <Dropdown
                className="project-sorter"
                placeholder="Sortieren"
                fluid
                search
                selection
                options={sortOptions}
                onChange={this.handleSortChange}
                value={value}
                compact
            />
        );
    };

    handleSortChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.ProjectStore.sort = data.value;

        this.setState({
            value: data.value
        });
    };

    private initSorter(): void {
        const options: DropdownItemProps[] = [
            { key: "id-asc", text: "Nummer (aufsteigend)", value: "id-asc" },
            { key: "id-desc", text: "Nummer (absteigend)", value: "id-desc" },
            { key: "typeId-asc", text: "Typ (aufsteigend)", value: "typeId-asc" },
            { key: "typeId-desc", text: "Typ (absteigend)", value: "typeId-desc" },
            { key: "name-asc", text: "Name (aufsteigend)", value: "name-asc" },
            { key: "name-desc", text: "Name (absteigend)", value: "name-desc" },
            { key: "updatedAt-desc", text: "Zuletzt geändert", value: "updatedAt-desc" },
            { key: "updatedAt-asc", text: "Lange unverändert", value: "updatedAt-asc" },
            { key: "createdAt-desc", text: "Neueste", value: "createdAt-desc" },
            { key: "createdAt-asc", text: "Älteste", value: "createdAt-asc" },
            { key: "closedOn-desc", text: "Zuletzt abgeschlossen", value: "closedOn-desc" },
            { key: "isClosed-asc", text: "Aktiv", value: "isClosed-asc" }
        ];

        this.setState({
            sortOptions: options
        });
    }

}
